import { Colors } from "./colors";

// theme file for entire app

export const AppTheme = {
  roundness2: 2,
  roundness4: 4,
  roundness8: 8,
  roundness: 8,
  roundness16: 16,
  fontSize: {
    caption: 10,
    preHeading: 12,
    paragraph: 14,
    subHeading: 16,
    title: 18,
    headline: 20,
    largeTitle: 22,
    extraLargeTitle: 24,
    subcaption: 8,
    MegaTitle: 30,
  },
  spacing: {
    xs: 2,
    sm: 4,
    md: 8,
    space12: 12,
    space14: 14,
    lg: 16,
    space18: 18,
    space20: 20,
    space28: 28,
    space35: 35,
    space36: 36,
    space40: 40,
    space50: 50,
    xl: 32,
    space24: 24,
    xxl: 64,
    xxs: 1,
    space100: 100,
  },
  color: {
    light: {
      primaryColor: Colors.primary,
      secondaryColor: Colors.secondary,
      light: Colors.white,
      dark: Colors.black
    },
    dark: {
      primaryColor: Colors.secondary,
      secondaryColor: Colors.primary,
      light: Colors.black,
      dark: Colors.white,
    },
  },
};
